import React, { useState, useEffect } from "react";
import { NavBar, List } from "antd-mobile";
import {getNavBarContainerStyle} from "../../../../utils/deviceUtils";
import { CheckCircleFill } from "antd-mobile-icons";
import { useNavigate } from "react-router-dom";
import { t } from "../../../../i18n";
import { isAppVersionGreaterThanOrEqual, kNativeMapNavigationVersion, kAndroidWazeVersion, kIOSWazeVersion } from "../../../../utils/versionUtils";
import {getUserInfo} from "../../../../utils/auth";
import { isDspManager } from "../../../../utils/auth";

interface NavigationAppPage {}

const PickupNavigationAppPage: React.FC<NavigationAppPage> = () => {
    const navigate = useNavigate();
    const [selectedApp, setSelectedApp] = useState('google');
    const [isIOS, setIsIOS] = useState(false);
    const [isNativeNavigationSupported, setIsNativeNavigationSupported] = useState(false);
    const [showWaze, setShowWaze] = useState(false);
    const userInfo = getUserInfo();
    const reviewAccount = userInfo?.account?.id === '216';

    useEffect(() => {
        // 检测是否为iOS设备
        setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent));
    }, []);

    useEffect(() => {
        // 从本地存储读取已保存的导航应用设置，默认为Google Map
        const savedApp = localStorage.getItem('navigationApp') || 'google';
        setSelectedApp(savedApp);
    }, []);

    useEffect(() => {
        // 检查是否支持原生导航
        const checkNativeLocationSupport = async () => {
            const isSupported = await isAppVersionGreaterThanOrEqual(kNativeMapNavigationVersion);
            setIsNativeNavigationSupported(isSupported && reviewAccount);
        };
        checkNativeLocationSupport();
    }, []);

    useEffect(() => {
        // 检查是否显示 Waze 选项
        // Android: 版本 >= 8.1.0 才显示
        // iOS: 版本 >= 8.6.0 才显示
        const checkWazeVisibility = async () => {
            const targetVersion = isIOS ? kIOSWazeVersion : kAndroidWazeVersion;
            const shouldShow = await isAppVersionGreaterThanOrEqual(targetVersion);
            setShowWaze(shouldShow);
        };
        checkWazeVisibility();
    }, [isIOS]);

    const handleAppChange = (app: string) => {
        setSelectedApp(app);
        // 保存到本地存储
        localStorage.setItem('navigationApp', app);
    };

    return (
        <div className="flex flex-col h-screen bg-white">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                onBack={() => navigate(-1)}
            >
                {t('pages.useMenu.navigationApp')}
                </NavBar>
            </div>

            <List className="mt-2">
                <List.Item
                    extra={selectedApp === 'google' ? <CheckCircleFill color="#00b578" /> : null}
                    onClick={() => handleAppChange('google')}
                    arrowIcon={false}
                >
                    {t('pages.delivery.orderDetail.googleMaps')}
                </List.Item>
                {
                    isIOS && <List.Item
                        extra={selectedApp === 'apple' ? <CheckCircleFill color="#00b578" /> : null}
                        onClick={() => handleAppChange('apple')}
                        arrowIcon={false}
                    >
                        {t('pages.delivery.orderDetail.appleMaps')}
                    </List.Item>
                }
                {
                    showWaze && <List.Item
                        extra={selectedApp === 'waze' ? <CheckCircleFill color="#00b578" /> : null}
                        onClick={() => handleAppChange('waze')}
                        arrowIcon={false}
                    >
                        {t('pages.delivery.orderDetail.wazeMaps')}
                    </List.Item>
                }
                {
                    isNativeNavigationSupported && !isDspManager() && <List.Item
                        extra={selectedApp === 'inapp' ? <CheckCircleFill color="#00b578" /> : null}
                        onClick={() => handleAppChange('inapp')}
                        arrowIcon={false}
                    >
                        {t('pages.delivery.orderDetail.mapBoxMaps')}
                    </List.Item>
                }
            </List>
        </div>
    );
};

export default PickupNavigationAppPage;

